var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.7315 21.4353L17.2599 15.9637C18.7509 14.1401 19.4841 11.8131 19.3076 9.46414C19.1311 7.11516 18.0585 4.92386 16.3117 3.34352C14.5648 1.76318 12.2774 0.914696 9.92255 0.973575C7.56768 1.03245 5.32552 1.99419 3.65986 3.65986C1.99419 5.32552 1.03245 7.56768 0.973575 9.92255C0.914696 12.2774 1.76318 14.5648 3.34352 16.3117C4.92386 18.0585 7.11516 19.1311 9.46414 19.3076C11.8131 19.4841 14.1401 18.7509 15.9637 17.2599L21.4353 22.7315C21.6082 22.8984 21.8397 22.9908 22.0801 22.9887C22.3204 22.9867 22.5503 22.8903 22.7203 22.7203C22.8903 22.5503 22.9867 22.3204 22.9887 22.0801C22.9908 21.8397 22.8984 21.6082 22.7315 21.4353ZM10.1667 17.5C8.71631 17.5 7.29849 17.07 6.09253 16.2642C4.88657 15.4584 3.94664 14.313 3.39159 12.9731C2.83655 11.6331 2.69133 10.1586 2.97429 8.73605C3.25724 7.31352 3.95568 6.00685 4.98126 4.98126C6.00685 3.95568 7.31352 3.25724 8.73605 2.97429C10.1586 2.69133 11.6331 2.83655 12.9731 3.39159C14.313 3.94664 15.4584 4.88657 16.2642 6.09253C17.07 7.29849 17.5 8.71631 17.5 10.1667C17.4979 12.111 16.7245 13.975 15.3497 15.3497C13.975 16.7245 12.111 17.4979 10.1667 17.5Z",
    fill: "#172A47"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.b469c07ae8be3c378aec3b02168cd4a5.svg";
export { ForwardRef as ReactComponent };